import Vue from 'vue';
import { limitImgUrl } from '../utils/common';

export const bus = new Vue();
Vue.prototype.$ossLimit = limitImgUrl;
Vue.prototype.$bus = bus;

// directives
Vue.directive('focus', {
  mounted(el) {
    if (el.nodeName === 'input') {
      el.focus();
    } else {
      const _el = el.getElementsByTagName('input')[0];
      if (_el) _el.focus();
    }
  }
});
